import { render, staticRenderFns } from "./WashInstrumentList.vue?vue&type=template&id=81a0d4b4&"
import script from "./WashInstrumentList.vue?vue&type=script&lang=js&"
export * from "./WashInstrumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports